import { nanoid } from "nanoid";
import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { api, baseURL, customerReqConfig } from "../../src/include/api";

const DiscountOne = () => {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [slideList, setSlideList] = useState([]);

  const getSlides = () => {
    setFetchLoading(true);
    api
      .get("/slide_show/", customerReqConfig)
      .then((response) => {
        if (response.status === 200) {
          setSlideList(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching slides", error);
      })
      .finally(() => {
        setFetchLoading(false);
      });
  };

  useEffect(() => {
    getSlides();
  }, []);

  // Filter slides for each container
  const bestSellerSlides = slideList?.filter(
    (slide) =>
      slide.status === "active" &&
      slide.view === "web" &&
      slide.type === "best seller",
  );
  const hotDealsSlides = slideList?.filter(
    (slide) =>
      slide.status === "active" &&
      slide.view === "web" &&
      slide.type === "hot deals",
  );
  const bottomSlides = slideList?.filter(
    (slide) =>
      slide.status === "active" &&
      slide.view === "web" &&
      slide.type === "day deals",
  );

  return (
    <section className="discount py-30">
      <div className="container container-lg">
        <div className="row gy-4">
          <div className="col-xl-6">
            <div className="discount-item rounded-16 overflow-hidden position-relative z-1 h-100 d-flex flex-column align-items-start justify-content-center">
              {fetchLoading ? (
                <div className="w-100 bg-light" />
              ) : (
                <Carousel
                  autoPlay
                  infiniteLoop
                  interval={3000}
                  preventMovementUntilSwipeScrollTolerance
                  showThumbs={false}
                  transitionTime={100}
                  showStatus={false}
                  showIndicators={false} // Hides bottom dots
                >
                  {bestSellerSlides?.map((slide) => (
                    <CarouselItem slide={slide} key={nanoid()} />
                  ))}
                </Carousel>
              )}
            </div>
          </div>
          <div className="col-xl-6">
            <div className="discount-item rounded-16 overflow-hidden position-relative z-1 h-100 d-flex flex-column align-items-center justify-content-center">
              {fetchLoading ? (
                <div className="w-100 bg-light" />
              ) : (
                <Carousel
                  autoPlay
                  infiniteLoop
                  interval={3000}
                  preventMovementUntilSwipeScrollTolerance
                  showThumbs={false}
                  transitionTime={100}
                  showStatus={false}
                  showIndicators={false} // Hides bottom dots
                >
                  {hotDealsSlides?.map((slide) => (
                    <CarouselItem slide={slide} key={nanoid()} />
                  ))}
                </Carousel>
              )}
            </div>
          </div>
        </div>

        <div className=" mt-3 p-4 pt-0 pb-0">
          <div className="bg-white ">
            {fetchLoading ? (
              <div
                className="bg-light"
                style={{ width: "1200px", height: "300px" }}
              />
            ) : (
              <Carousel
                autoPlay
                infiniteLoop
                interval={3000}
                preventMovementUntilSwipeScrollTolerance
                showThumbs={false}
                transitionTime={100}
                showStatus={false}
                showIndicators={false} // Hides bottom dots
              >
                {bottomSlides?.map((slide) => (
                  <CarouselItem slide={slide} key={nanoid()} />
                ))}
              </Carousel>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

const CarouselItem = ({ slide }) => {
  const handleClick = () => {
    if (slide.linkUrl) {
      window.open(slide.linkUrl);
    }
  };
  return (
    <div
      className="mx-2"
      style={{ height: "100%", flex: "1 1 0", cursor: "pointer" }}
      onClick={handleClick}
    >
      <img
        className="fit-cover w-100 h-100"
        src={slide.imageUrl ? `${baseURL}/${slide.imageUrl}` : ""}
        alt=""
      />
    </div>
  );
};

export default DiscountOne;
